import React from 'react';

// Color constants (matching AppOnboardingPage theme)
const TEXT_DARK = '#1A1A2E';
const TEXT_SECONDARY = '#6B7280';
const BORDER_LIGHT = '#D1D5DB';

interface TopBarProps {
  title: string;
  /** Optional custom content to render instead of title (e.g. dropdown). When set, title is used for accessibility only. */
  titleContent?: React.ReactNode;
  onBack?: () => void;
  /** When false, the countdown bar is hidden. Default true. */
  showCountdown?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ title, titleContent, onBack, showCountdown = true }) => {
  return (
    <header
      className="shrink-0 w-full"
      style={{
        background: '#F9FAFB',
        backdropFilter: 'blur(10px)',
        color: TEXT_DARK,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderBottom: `1px solid ${BORDER_LIGHT}`,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
      }}
    >
      {/* Title section with centered content */}
      <div
        style={{
          width: '100%',
          height: 50,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          padding: '0 20px',
        }}
      >
        {onBack && (
          <button
            onClick={onBack}
            style={{
              position: 'absolute',
              left: 12,
              width: 32,
              height: 32,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(59, 123, 244, 0.08)',
              border: `1px solid ${BORDER_LIGHT}`,
              borderRadius: '50%',
              color: TEXT_SECONDARY,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              fontSize: 18,
              padding: 0,
            }}
            aria-label="Back"
          >
            ‹
          </button>
        )}
        <p
          style={{
            margin: 0,
            fontSize: 16,
            fontWeight: 600,
            textAlign: 'center',
            letterSpacing: '0.3px',
            color: TEXT_DARK,
          }}
          aria-label={title}
        >
          {titleContent ?? title}
        </p>
      </div>
    </header>
  );
};

export default TopBar;
